import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import UIList from 'UIComponents/list/UIList';
import styled from 'styled-components';
import Small from 'UIComponents/elements/Small';
import UIFlex from 'UIComponents/layout/UIFlex';
import UISelectableBox from 'UIComponents/button/UISelectableBox';
import { GRID_BREAKPOINT_MEDIUM } from 'HubStyleTokens/sizes';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import UsageTracker from '../../utils/UsageTracker';
const MaxWidthUIList = styled(UIList).withConfig({
  displayName: "WizardChooseMotivation__MaxWidthUIList",
  componentId: "sc-1jxkdu6-0"
})(["width:100%;@media (min-width:", "){max-width:400px;}"], GRID_BREAKPOINT_MEDIUM);
const MultiLineButton = styled(UISelectableBox).withConfig({
  displayName: "WizardChooseMotivation__MultiLineButton",
  componentId: "sc-1jxkdu6-1"
})(["line-height:1.2;"]);
const ButtonFlexContainer = styled(UIFlex).withConfig({
  displayName: "WizardChooseMotivation__ButtonFlexContainer",
  componentId: "sc-1jxkdu6-2"
})(["padding-top:8px;"]);

const WizardChooseMotivation = ({
  resultCountTotal,
  resultCountTotalCertsOnly,
  onMotivationClick
}) => {
  const trackButtonClick = certsOnly => {
    UsageTracker.track('wizardInteraction', {
      action: certsOnly ? 'wizard-click-show-certs-only' : 'wizard-click-show-all-courses',
      resultCount: certsOnly ? resultCountTotalCertsOnly : resultCountTotal
    });
  };

  return /*#__PURE__*/_jsxs(MaxWidthUIList, {
    childClassName: "m-bottom-4",
    children: [/*#__PURE__*/_jsx(MultiLineButton, {
      block: true,
      "data-test-id": "show-certs-only-button",
      flush: true,
      height: 56,
      onClick: () => {
        onMotivationClick(true);
        trackButtonClick(true);
      },
      readOnly: resultCountTotalCertsOnly < 1,
      children: /*#__PURE__*/_jsxs(ButtonFlexContainer, {
        align: "center",
        direction: "column",
        children: [/*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.wizard.modal.motivationbuttons.advancecareer"
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `learningCenter.wizard.modal.motivationbuttons.showcertscount`,
              options: {
                totalCount: resultCountTotalCertsOnly
              }
            })
          })
        })]
      })
    }), /*#__PURE__*/_jsx(MultiLineButton, {
      block: true,
      "data-test-id": "show-all-button",
      flush: true,
      height: 56,
      onClick: () => {
        onMotivationClick(false);
        trackButtonClick(false);
      },
      children: /*#__PURE__*/_jsxs(ButtonFlexContainer, {
        align: "center",
        direction: "column",
        children: [/*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `learningCenter.wizard.modal.motivationbuttons.currenttrends`
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `learningCenter.wizard.modal.motivationbuttons.showallcount`,
              options: {
                totalCount: resultCountTotal
              }
            })
          })
        })]
      })
    })]
  });
};

export default WizardChooseMotivation;